module.exports = __webpack_public_path__ + "static/img/about-bg.e0c0796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-bg.png
// module id = j313
// module chunks = 0